import { render, staticRenderFns } from "./OneService.vue?vue&type=template&id=5cff6e20&scoped=true&"
import script from "./OneService.vue?vue&type=script&lang=ts&"
export * from "./OneService.vue?vue&type=script&lang=ts&"
import style0 from "./OneService.vue?vue&type=style&index=0&id=5cff6e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cff6e20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
